function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.1 9.6L4.7.6c-.9-.6-2.1-.7-3-.2C.7.9.1 1.9.1 3v18.2c0 1.1.6 2.1 1.6 2.6.4.1.8.2 1.3.2.6 0 1.2-.2 1.7-.6l12.4-9.1c.7-.6 1.2-1.4 1.2-2.4 0-.8-.4-1.7-1.2-2.3z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24"
  }, props), _ref);
};

export default SvgComponent;